import type { NftMiniature } from "@anaconda/core/nft/types"
import { createScope } from "bunshi"

export const NftsToSellScopeReatom = createScope<NftMiniature[]>([])
